import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { SelectOption } from 'QuoteApp/services/endpoints/GetConfig';
import { FormInput } from 'Shared/components';

import { PriceCustomizerFormValues } from '../domain';
import styles from './styles.module.css';

type WeekdaySelectorType = {
  isLoading?: boolean;
  options: Array<SelectOption<string>>;
  name: string;
  onChange?: (value: string) => void;
};

export const WeekdaySelector: FC<WeekdaySelectorType> = ({
  isLoading,
  options,
  name,
  onChange,
}) => {
  const { handleBlur, setFieldValue, values } =
    useFormikContext<PriceCustomizerFormValues>();

  const handleChange = (selectedValue: string) => {
    setFieldValue(name, selectedValue);

    if (onChange) {
      onChange(selectedValue);
    }
  };

  const transformOptions = (
    options: Array<SelectOption<string>>
  ): { [value: string]: string } => {
    return options.reduce(
      (acc, option) => {
        acc[option.value] = option.label;
        return acc;
      },
      {} as { [value: string]: string }
    );
  };

  return (
    <FormInput
      data-testid="payflex-weekday"
      variant="selectAutocomplete"
      name={name}
      label="Payments due on"
      value={values.dayOfWeek}
      disabled={isLoading}
      className={styles.weekdaySelector}
      options={transformOptions(options)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
